<template>
  <div v-if="items.length" class="breadcrumbs">
    <div class="breadcrumbs__back">
      <m4-button tag="a" :href="backUrl" variant="default-text">
        <m4-icon icon="angle-left"></m4-icon>
      </m4-button>
    </div>
    <ul class="breadcrumbs__items">
      <li v-for="(item, i) in items" :key="i" :class="'breadcrumbs__items__item'">
        <m4-icon v-if="i != 0" icon="angle-right"></m4-icon>
        <span v-if="items.length - 1 == i" class="btn--last">
          {{ item.title }}
        </span>
        <m4-button v-else tag="a" :href="item.url" variant="default-text">
          {{ item.title }}
        </m4-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "M4Breadcrumbs",
  props: {
    backUrl: {
      type: String,
      default() {
        return "javascript:window.history.back()";
      }
    },
    items: Array
  }
};
</script>
